__turbopack_context__.v({
  "ctaContainer": "HeroCatSection-module__tM_jfW__ctaContainer",
  "description": "HeroCatSection-module__tM_jfW__description",
  "disclaimer": "HeroCatSection-module__tM_jfW__disclaimer",
  "imgContainer": "HeroCatSection-module__tM_jfW__imgContainer",
  "imgTextContainer": "HeroCatSection-module__tM_jfW__imgTextContainer",
  "linkModalContent": "HeroCatSection-module__tM_jfW__linkModalContent",
  "root": "HeroCatSection-module__tM_jfW__root",
  "textContainer": "HeroCatSection-module__tM_jfW__textContainer",
  "vidContainer": "HeroCatSection-module__tM_jfW__vidContainer",
});
